import { render, staticRenderFns } from "./verifyCode.vue?vue&type=template&id=ddec7e34&scoped=true"
import script from "./verifyCode.vue?vue&type=script&lang=js"
export * from "./verifyCode.vue?vue&type=script&lang=js"
import style0 from "./verifyCode.vue?vue&type=style&index=0&id=ddec7e34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddec7e34",
  null
  
)

export default component.exports